module.exports = __webpack_public_path__ + "static/media/email.937e25c7.svg";